import { useEffect } from 'react'
import HeaderLayout from '../../../../layouts/Header'
import { useNav, useParseQuery } from '../../../../hooks/useNav'

import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import Select from '../../../../components/function/filters/Select'
import Date from '../../../../components/function/filters/Date'
import DropDownList from '../../../../components/function/filters/DropDownList'
import SearchHeader from '../../../../components/function/filters/SearchHeader'
import { PATH } from '../../../../data/router_path'
import { ERROR_REPORT_OPTIONS } from '../../../../data/constants'
import { convertFilterDateFormat } from '../../../../utils/conversion'
import { showErrorToast } from '../../../../utils/showToast'
const errorReportFilterSchema = z.object({
  keyword: z.string().nullable().optional(),
  all_radio: z.boolean().nullable().optional(),
  date_range_radio: z.boolean().nullable().optional(),
  date_from: z.string().nullable().optional(),
  date_to: z.string().nullable().optional(),
  status: z.string().optional().nullable(),
  os: z.string().optional().nullable(),
})
export default function ErrorReportFilterHeader() {
  const navigate = useNav()
  const { queryParams } = useParseQuery()
  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(errorReportFilterSchema),
    defaultValues: {
      keyword: '',
      all_radio: true,
      date_range_radio: false,
      date_from: undefined,
      date_to: undefined,
      status: ERROR_REPORT_OPTIONS.STATUS[0].value,
      os: ERROR_REPORT_OPTIONS.OS[0].value,
    },
  })
  const searchHandler = (formValue) => {
    const {
      all_radio,
      date_range_radio,
      keyword,
      status,
      os,
      date_from,
      date_to,
    } = formValue
    let filters = { ...queryParams, keyword, status, os }
    if (all_radio) {
      filters.createdDate = undefined
    }
    if (date_range_radio) {
      if (!date_from || !date_to) {
        showErrorToast({
          message: 'Vui lòng chọn đủ khoảng ngày',
        })
        return
      }
      filters.createdDate = `${convertFilterDateFormat(date_from)}-${convertFilterDateFormat(date_to)}`
    }

    navigate(PATH.SYSTEM.ERRORS_REPORT.LIST, { params: filters })
  }
  const handleRadioChange = (selectedName, newValue) => {
    if (newValue) {
      setValue('all_radio', selectedName === 'all_radio')
      setValue('date_range_radio', selectedName === 'date_range_radio')
    } else {
      setValue('all_radio', true)
    }
  }
  return (
    <HeaderLayout>
      <form
        onSubmit={handleSubmit(searchHandler)}
        className={'flex flex-col justify-center gap-4'}
      >
        <SearchHeader
          title={'Danh sách báo lỗi'}
          placeholder="Tìm kiếm tên tài khoản, mã tài khoản..."
          control={control}
          name={'keyword'}
        />
        <div className="flex items-center justify-between gap-4 text-base font-semibold">
          <Select
            control={control}
            name={'all_radio'}
            title={'Tất cả'}
            onChangeHandler={handleRadioChange}
          />
          <div className="flex items-center">
            <Select
              control={control}
              name={'date_range_radio'}
              onChangeHandler={handleRadioChange}
            />

            <div className="flex items-center gap-3">
              <Date control={control} name={'date_from'} title={'Từ'} />
              <Date control={control} name={'date_to'} title={'Đến'} />
            </div>
          </div>

          <DropDownList
            control={control}
            name={'status'}
            title={'Trạng thái lỗi'}
            options={ERROR_REPORT_OPTIONS.STATUS}
          />
          <DropDownList
            control={control}
            name={'os'}
            title={'Hệ điều hành'}
            options={ERROR_REPORT_OPTIONS.OS}
          />
        </div>
      </form>
    </HeaderLayout>
  )
}
